import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'app/components/ui/dialog'
import { Button } from 'app/components/ui/button'

export type ConfirmationAlertShadcnComponentProps = {
  open: boolean
  variant: `danger` | `info`
  title: string
  description: string
  submitLabel?: string
  cancelLabel?: string
  onSubmit: () => void
  onClose: () => void
}

export function ConfirmationAlertShadcnComponent({
  open,
  variant,
  title,
  description,
  submitLabel = `Confirm`,
  cancelLabel = `Cancel`,
  onSubmit,
  onClose,
}: ConfirmationAlertShadcnComponentProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-lg gap-0 p-0">
        <DialogHeader className="border-b border-default px-6 py-3">
          <DialogTitle className="text-lg font-semibold leading-tight text-strong">{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap px-6 py-4 text-body-xs text-default">
          {description}
        </DialogDescription>
        <DialogFooter className="border-t border-default px-6 py-3 gap-4">
          <Button variant="white" size="md" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button variant={variant === `danger` ? `danger` : `primary`} size="md" onClick={onSubmit}>
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
